export const SkillsJson = [
  {
    id: 1,
    tech: 'HTML',
    value: 'INTERMEDIÁRIO',
    description: 'HTML é uma linguagem de marcação utilizada na construção de páginas na Web. Documentos HTML podem ser interpretados por navegadores. A tecnologia é fruto da junção entre os padrões HyTime e SGML. HyTime é um padrão para a representação estruturada de hipermídia e conteúdo baseado em tempo'
  },
  {
    id: 2,
    tech: 'CSS',
    value: 'INTERMEDIÁRIO',
    description: 'Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web, aplicado diretamente nas tags HTML ou ficar contido dentro das tags <style>. Também é possível, adicionar estilos adicionando um link para um arquivo CSS que contém os estilos'
  },
  {
    id: 3,
    tech: 'JAVASCRIPT',
    value: 'INTERMEDIÁRIO',
    description: 'JavaScript é uma linguagem de programação interpretada estruturada, de script em alto nível com tipagem dinâmica fraca e multiparadigma. Juntamente com HTML e CSS, o JavaScript é uma das três principais tecnologias da World Wide Web.'
  },
  {
    id: 4,
    tech: 'NODE',
    value: 'BÁSICO',
    description: 'O Node.js é uma plataforma que usa a linguagem JavaScript para executar código fora do navegador. Ele é usado para criar aplicações web, APIs, microsserviços, chatbots e aplicações desktop. '
  },
  {
    id: 5,
    tech: 'TYPESCRIPT',
    value: 'BÁSICO',
    description: 'TypeScript é uma linguagem de programação de código aberto desenvolvida pela Microsoft. É um superconjunto sintático estrito de JavaScript e adiciona tipagem estática opcional à linguagem.'
  },
  {
    id: 6,
    tech: 'VUE.JS',
    value: 'INTERMEDIÁRIO',
    description: 'Vue.js é um framework JavaScript de código-aberto, focado no desenvolvimento de interfaces de usuário e aplicativos de página única.'
  },
  {
    id: 7,
    tech: 'REACT.JS',
    value: 'INTERMEDIÁRIO',
    description: 'O React é uma biblioteca front-end JavaScript de código aberto com foco em criar interfaces de usuário em páginas web.'
  },
  {
    id: 8,
    tech: 'JAVA',
    value: 'BÁSICO',
    description: 'Java é uma linguagem de programação orientada a objetos desenvolvida na década de 90 por uma equipe de programadores chefiada por James Gosling, na empresa Sun Microsystems, que em 2008 foi adquirido pela empresa Oracle Corporation.'
  },
]